import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "h-20 overflow-hidden",
  style: {"margin-top":"-80px","padding-top":"100px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { style: {"height":"25rem","border-radius":"100% 100% 0 0","background":"#f3f4f6","transform":"scale(1.5)"} })
], -1)
const _hoisted_4 = {
  class: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8",
  style: {"position":"relative","margin-top":"-160px"}
}
const _hoisted_5 = { class: "-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5 justify-center" }
const _hoisted_6 = { class: "flex justify-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "grow text-l font-bold text-gray-900 mt-4 text-center" }
const _hoisted_9 = { class: "mt-4 pt-4 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", { class: "font-bold inline-block mr-4" }, "出身地", -1)
const _hoisted_13 = { class: "inline-block" }
const _hoisted_14 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", { class: "font-bold inline-block mr-4" }, "戒名・法名", -1)
const _hoisted_16 = { class: "inline-block" }
const _hoisted_17 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("dt", { class: "font-bold inline-block mr-4" }, "享年", -1)
const _hoisted_19 = { class: "inline-block" }
const _hoisted_20 = { class: "flex items-center mt-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("dt", { class: "inline-block font-bold mr-2" }, "フォロワー", -1)
const _hoisted_22 = { class: "inline-block" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)
const _hoisted_24 = { class: "mt-2 flex justify-end space-y-3 sm:flex-row sm:space-y-0 sm:space-x-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "編集", -1)
const _hoisted_26 = {
  key: 1,
  class: "relative inline-block text-left"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  class: "-mr-1 ml-2 h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "フォローを外す", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_32 = { class: "mt-5 grid grid-cols-3 gap-2" }
const _hoisted_33 = { class: "col-span-3 bg-white shadow rounded-lg flex justify-center items-center" }
const _hoisted_34 = { class: "text-sm font-medium text-gray-900 truncate p-4" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "max-w-5xl mx-auto sm:px-6 lg:px-8" }
const _hoisted_37 = { class: "px-4 mt-4 flex justify-between items-center" }
const _hoisted_38 = { class: "flex items-center" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "ml-2 text-sm text-gray-400" }
const _hoisted_41 = { class: "border-b border-gray-200" }
const _hoisted_42 = {
  class: "-mb-px flex",
  "aria-label": "Tabs"
}
const _hoisted_43 = {
  key: 0,
  class: "mt-4 max-w-3xl mx-auto sm:px-6 lg:px-8 overflow-x-hidden"
}
const _hoisted_44 = {
  key: 0,
  class: "mt-4 mb-4 p-4 bg-white"
}
const _hoisted_45 = { class: "min-w-0 flex-1" }
const _hoisted_46 = { class: "relative" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  for: "comment",
  class: "sr-only"
}, "あなたのお名前、思い出の写真・動画や、エピソード等を投稿いただけます", -1)
const _hoisted_48 = ["src"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", {
  class: "py-2",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "py-px" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-9" })
  ])
], -1)
const _hoisted_50 = { class: "absolute bottom-0 inset-x-0 pl-3 pr-2 py-2 flex justify-between" }
const _hoisted_51 = { class: "flex items-center space-x-5" }
const _hoisted_52 = { class: "flex items-center" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "flex-shrink-0" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 0,
  class: "text-xs text-red-600"
}
const _hoisted_57 = {
  role: "list",
  class: "flex flex-col justify-center items-stretch gap-y-4"
}
const _hoisted_58 = { class: "flex mt-2 items-center space-x-3" }
const _hoisted_59 = { class: "flex-shrink-0" }
const _hoisted_60 = ["src"]
const _hoisted_61 = { class: "flex-1 min-w-0" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute inset-0",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_63 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "flex justify-center" }
const _hoisted_66 = {
  key: 0,
  class: "mt-4 group block aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 overflow-hidden"
}
const _hoisted_67 = ["src"]
const _hoisted_68 = ["innerHTML"]
const _hoisted_69 = { class: "mt-4 flex justify-between" }
const _hoisted_70 = {
  key: 0,
  class: "text-xs text-gray-400"
}
const _hoisted_71 = { class: "text-xs text-gray-400" }
const _hoisted_72 = {
  key: 0,
  class: "flex-1 min-w-0 items-end"
}
const _hoisted_73 = ["onClick"]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", null, "承認", -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = {
  key: 1,
  class: "py-4"
}
const _hoisted_77 = { class: "max-w-3xl mx-auto sm:px-6 lg:px-8" }
const _hoisted_78 = { class: "flex flex-col justify-center items-stretch gap-y-4" }
const _hoisted_79 = { class: "flex justify-center" }
const _hoisted_80 = { class: "group block aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden" }
const _hoisted_81 = ["src"]
const _hoisted_82 = { class: "mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none" }
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = { class: "mt-2 flex space-x-6" }
const _hoisted_85 = { class: "inline-flex items-center text-sm" }
const _hoisted_86 = {
  type: "button",
  class: "inline-flex space-x-2 text-gray-400"
}
const _hoisted_87 = ["src"]
const _hoisted_88 = { class: "font-medium text-gray-400" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "replies", -1)
const _hoisted_90 = { class: "inline-flex items-center text-sm" }
const _hoisted_91 = {
  type: "button",
  class: "inline-flex space-x-2 text-gray-400 hover:text-gray-500"
}
const _hoisted_92 = ["src"]
const _hoisted_93 = { class: "font-medium text-gray-400" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "likes", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("span", { class: "grow" }, null, -1)
const _hoisted_96 = { class: "text-xs text-gray-600" }
const _hoisted_97 = {
  key: 2,
  class: "p-4"
}
const _hoisted_98 = { class: "relative max-w-7xl mx-auto px-4 sm:pb-24 sm:px-6 lg:px-8" }
const _hoisted_99 = { class: "max-w-2xl mx-auto grid grid-cols-1 gap-x-6 gap-y-10 lg:max-w-none" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-900" }, "歿年月日", -1)
const _hoisted_102 = { class: "mt-2 font-medium text-sm text-gray-500" }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-900" }, "生年月日", -1)
const _hoisted_105 = { class: "mt-2 font-medium text-sm text-gray-500" }
const _hoisted_106 = { key: 2 }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-900" }, "経歴", -1)
const _hoisted_108 = { class: "mt-2 font-medium text-sm text-gray-500" }
const _hoisted_109 = { key: 3 }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-900" }, "出身地", -1)
const _hoisted_111 = { class: "mt-2 font-medium text-sm text-gray-500" }
const _hoisted_112 = { key: 4 }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-900" }, "趣味", -1)
const _hoisted_114 = { class: "mt-2 font-medium text-sm text-gray-500" }
const _hoisted_115 = { key: 5 }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-900" }, "生前の学校", -1)
const _hoisted_117 = { class: "mt-2 font-medium text-sm text-gray-500" }
const _hoisted_118 = { key: 6 }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-900" }, "生前の仕事", -1)
const _hoisted_120 = { class: "mt-2 font-medium text-sm text-gray-500" }
const _hoisted_121 = { key: 7 }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm text-gray-900" }, "叙勲歴", -1)
const _hoisted_123 = { class: "mt-2 font-medium text-sm text-gray-500" }
const _hoisted_124 = {
  key: 3,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_126 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_127 = { class: "flex items-center justify-center min-h-full p-4 text-center md:w-[80%] sm:p-0" }
const _hoisted_128 = { class: "relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all w-[80%] sm:my-8 sm:max-w-sm sm:w-full sm:p-6" }
const _hoisted_129 = { class: "flex justify-end items-center" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("h3", {
  class: "mx-auto text-lg leading-6 font-medium text-gray-900",
  id: "modal-title"
}, " フォローしている方 ", -1)
const _hoisted_131 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_132 = { class: "mt-2" }
const _hoisted_133 = ["src"]
const _hoisted_134 = { class: "flex items-center" }
const _hoisted_135 = ["src"]
const _hoisted_136 = { class: "ml-3 flex flex-col items-start" }
const _hoisted_137 = { class: "text-sm text-gray-500" }
const _hoisted_138 = { class: "text-xs text-gray-500" }
const _hoisted_139 = {
  key: 4,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_141 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_142 = { class: "flex items-center justify-center min-h-full p-4 text-center md:w-[80%] sm:p-0" }
const _hoisted_143 = { class: "relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all w-[80%] sm:my-8 sm:max-w-sm sm:w-full sm:p-6" }
const _hoisted_144 = { class: "flex justify-end items-center" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("h3", {
  class: "mx-auto text-lg leading-6 font-medium text-gray-900",
  id: "modal-title"
}, " フォローしている方 ", -1)
const _hoisted_146 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_147 = { class: "mt-2" }
const _hoisted_148 = { class: "flex items-center" }
const _hoisted_149 = ["src"]
const _hoisted_150 = { class: "ml-3 flex flex-col items-start" }
const _hoisted_151 = { class: "text-sm text-gray-500" }
const _hoisted_152 = { class: "text-xs text-gray-500" }
const _hoisted_153 = ["onClick"]
const _hoisted_154 = {
  key: 0,
  class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
}
const _hoisted_155 = { class: "relative w-full transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("p", null, "故人とのご関係を選択してください", -1)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_158 = ["onClick"]
const _hoisted_159 = {
  key: 1,
  class: "flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0"
}
const _hoisted_160 = ["src"]
const _hoisted_161 = {
  key: 2,
  class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
}
const _hoisted_162 = { class: "relative w-full transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6" }
const _hoisted_163 = { class: "mt-5 sm:mt-6" }
const _hoisted_164 = { class: "group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden" }
const _hoisted_165 = ["src"]
const _hoisted_166 = ["onClick"]

import Album from "@/models/Album";
import Customer from "@/models/Customer";
import Decedent from "@/models/Decedent";
import Praying from "@/models/Praying";
import Timeline from "@/models/Timeline";
import {
  formatRelationshipLabel,
  formatSnsTime,
  formatStampTypeTitle,
} from "@/utils/TextUtil";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

// import {
//   PlusIcon,
//   PhoneIcon,
//   LocationMarkerIcon,
//   GlobeIcon,
// } from "@heroicons/vue/solid";

import { Auth, Storage } from "aws-amplify";
// import { uuid } from "vue-uuid";
// import moment from "moment";

import AppHeader from "@/components/AppHeader.vue";
import axios from "axios";
import moment from "moment";
import { uuid } from "vue-uuid";
import { MediaResource } from "@/models/MediaResource";


export default /*#__PURE__*/_defineComponent({
  __name: 'DecedentDetailView',
  setup(__props) {

// import { Options, Vue } from "vue-class-component";

const store = useStore();
const route = useRoute();

const decedent_id = ref<string>("");
const decedent = ref<Decedent>({} as Decedent);
const relationship = ref<string | null>(null);

const following = ref<boolean | null>(null);

const type = ref<string>("album");

const timelines = ref<Timeline[]>([]);
const albums = ref<Album[]>([]);

const image_url = ref<string | null>(null);
const comment = ref<string>("");
const comment_error = ref<string>("");

const show_follower_list = ref<boolean>(false);
const followers = ref<Customer[]>([]);

const prayedType = ref<string | null>(null);

const showing_modal = ref<boolean>(false);
const target_album = ref<Album | null>(null);
const show_follow_options = ref<boolean>(false);
const show_praying_image = ref<boolean>(false);

const login_result = ref<any>();
const message = ref<string>("");

const my_id = computed<string>(() => {
  return store.state.customer!.id;
});

const showFollowerList = () => {
  followers.value.length = 0;
  show_follower_list.value = true;

  setTimeout(async () => {
    followers.value = await getFollowersAsync();
  });
};

const decedentId = computed<string>(() => {
  return route.params.decedent_id as string;
});

const is_my_decedent = computed<boolean>(() => {
  if (!store.state.customer || !decedent_id.value) {
    return false;
  }

  return store.state.customer.decedent_ids.indexOf(decedent_id.value) >= 0;
});

const canViewDecedentAlbum = computed<boolean>(() => {
  if (decedent.value == null) {
    return false;
  }

  if (decedent.value!.scope == 'all') {
    return true;
  }

  if (decedent.value!.scope == 'follower' && relationship.value) {
    return true;
  }

  if (decedent.value!.scope == 'family' && relationship.value && relationship.value == "親族") {
    return true;
  }

  return false;
});

const formatdt = (dt: Date | null) => {
  return formatSnsTime(dt);
};

const formatstamp = (type: string) => {
  return formatStampTypeTitle(type);
};

const formatrel = (type: string | null) => {
  return formatRelationshipLabel(type);
};

const formatAlbumTitle = (album: Album) => {
  let title = `${album.publisher_name}さんが思い出を投稿しました`;
  if (album.publisher_relationship) {
    title = `${album.publisher_name}さん(${album.publisher_relationship})が思い出を投稿しました`;
  }

  if (decedent.value?.is_celebrity) {
    title = `${album.publisher_name}がアルバムを投稿しました`;
  }

  return title;
};

const refresh = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      decedent.value = await Decedent.get(decedent_id.value);
      await Promise.all([getAlbumAsync(), getFollwingAndRelationshipAsync(), getPrayedTypeAsync()]);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const refreshTimeline = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      await getTimelineAsync();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

// const getIsFollow = async (): Promise<void> => {
//   following.value = await Customer.isFollow(
//     store.state.customer!.id,
//     decedent_id.value
//   );
// };

const getTimelineAsync = async () => {
  timelines.value = await Timeline.searchByTarget(
    decedent_id.value,
    store.state.customer!.id,
    "event"
  );
  // console.log(timelines.value);
};

// const doLogin = () => {
//   // console.log(`doLogin(${email.value}, ${password.value})`);

//   store.dispatch("setLoading", true);
//   setTimeout(async () => {
//     try {
//       login_result.value = await Auth.signIn('rimoku@hasema-system.com', 'uyVEaXpaysLV');
//       console.log(login_result.value);

//     } catch (ex) {
//       const errorMessage = `${ex}`;
//       // console.log(errorMessage);

//       if (errorMessage.startsWith("NotAuthorizedException")) {
//         message.value = "ログインに失敗しました";
//       }
//     } finally {
//       store.dispatch("setLoading", false);
//     }
//   });
// };

const refreshAlbum = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      await getAlbumAsync();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const refreshPrayedType = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      await getPrayedTypeAsync();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const getAlbumAsync = async () => {
  const result = await Album.searchDecedent(decedent_id.value, store.state.customer!.id);
  albums.value = result.albums;
  // console.log(albums.value);
};

const getPrayedTypeAsync = async () => {
  const praying = await Praying.get(decedent_id.value, store.state.customer!.id);
  if (!praying) {
    prayedType.value = null;
  } else {
    prayedType.value = praying.stamp_type;
  }
};

const getFollwingAndRelationshipAsync = async (): Promise<void> => {
  // console.log(`getRelationshipAsync()`);
  const user = await Auth.currentAuthenticatedUser();

  const config = {
    headers: {
      Authorization: `${user.signInUserSession.idToken.jwtToken}}`,
    },
    params: {
      followee_id: decedentId.value,
    },
  };

  const response = await axios.get(
    `${process.env.VUE_APP_API_HOST}/followers/${store.state.customer!.id}_${decedent.value!.id}`,
    config
  );

  if (!response.data.data) {
    relationship.value = null;
    following.value = false;
  } else {
    relationship.value = response.data.data.relationship || null;
    following.value = true;
  }
};

const getFollowersAsync = async (): Promise<Customer[]> => {
  // console.log(`getFollowersAsync()`);
  const user = await Auth.currentAuthenticatedUser();

  const config = {
    headers: {
      Authorization: `${user.signInUserSession.idToken.jwtToken}}`,
    },
    params: {
      followee_id: decedentId.value,
    },
  };

  const response = await axios.get(
    `${process.env.VUE_APP_API_HOST}/followees`,
    config
  );

  // console.log(response);

  const list: Customer[] = [];

  response.data.data.forEach((json: any) => {
    // console.log(json);

    list.push(
      new Customer(
        json.id,
        json.username,
        json.family_name,
        json.family_name_kana,
        json.given_name,
        json.given_name_kana,
        json.selfie_image_url,
        json.email,
        json.decedent_ids,
        json.stripe_id,
        json.postcode,
        json.prefecture,
        json.city,
        json.address,
        json.building,
        json.telephone,
        json.follow_count,
        json.follower_count,
        json.post_count,
        json.relationship,
        new Date(json.created_at),
        new Date(json.updated_at),
        json.deleted_at ? new Date(json.deleted_at) : null
      )
    );
  });

  return list;
};

const setType = (t: string) => {
  type.value = t;

  if (type.value == "event") {
    refreshTimeline();
  } else {
    refreshAlbum();
  }
};

const formatDateTime = (dt: Date | undefined) => {
  if (!dt) {
    return "";
  }

  return moment(dt).format("YYYY年MM月DD日");
};

const togglePraying = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      if (prayedType.value) {
        prayedType.value = null;
        decedent.value!.praying_stamp1_count = Math.max(0, decedent.value!.praying_stamp1_count - 1);
        await Praying.delete(decedent.value!.id, store.state.customer!.id);
      } else {
        showing_modal.value = true;
        show_praying_image.value = true;

        prayedType.value = 'type1';
        decedent.value!.praying_stamp1_count = decedent.value!.praying_stamp1_count + 1;

        const result = await Praying.registerDecedent(
          decedentId.value,
          store.state.customer!.id,
          'type1'
        );

        setTimeout(() => {
          showing_modal.value = false;
          show_praying_image.value = false;
        }, 3000)
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const onCommentFocus = () => {
  if (relationship.value) {
    return;
  }
};

const onAlbumImageDropped = (e: DragEvent) => {
  // console.log("onAlbumImageDropped");
  if (!e.dataTransfer) {
    return;
  }

  const file = e.dataTransfer.files[0];
  const split = e.dataTransfer.files[0].name.split(".");
  const filename = uuid.v4();
  const extension = split[split.length - 1];
  const contentType = extension == "png" ? "image/png" : "image/jpg";

  setTimeout(async () => {
    Storage.configure({ customPrefix: { public: "albums" } });
    const s3response = await Storage.put(`/${filename}.${extension}`, file, {
      contentType: contentType,
    });

    // console.log(s3response);

    image_url.value = `${process.env.VUE_APP_HOST}/albums/${filename}.${extension}`;
    // console.log(image_url.value);
  });
};

const uploadfile = ref<HTMLInputElement>();

const onAttachmentButtonClicked = () => {
  const element = uploadfile.value;
  element?.click();
};

const comment_resource_url = ref<string>("");

const onUploadFileChanged = (e: Event) => {
  // console.log(e);

  const element = e.target as HTMLInputElement;
  if (!element.files) {
    return;
  }

  const file = element.files![0];

  if (!file) {
    return;
  }

  const split = file.name.split(".");
  const filename = uuid.v4();
  const extension = split[split.length - 1];
  const contentType = extension == "png" ? "image/png" : "image/jpg";
  setTimeout(async () => {
    Storage.configure({ customPrefix: { public: "albums" } });
    const s3response = await Storage.put(`/${filename}.${extension}`, file, {
      contentType: contentType,
    });
    // console.log(s3response);
    image_url.value = `${process.env.VUE_APP_HOST}/albums/${filename}.${extension}`;

    // console.log(image_url.value);
  });
};

const cancelUploadAlbum = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      image_url.value = null;
      comment.value = "";
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const registerAlbum = () => {
  if (store.state.is_loading) {
    return;
  }

  comment_error.value = "";

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      if (!store.state.customer) {
        return;
      }

      if (!comment.value && !image_url.value) {
        comment_error.value = "コメント等を入力してください";
        return;
      }

      const temp = new Album(
        "",
        0,
        store.state.customer!.id,
        store.state.customer!.display_name,
        store.state.customer!.username,
        store.state.customer!.selfie_image_url,
        relationship.value!,
        image_url.value
          ? new MediaResource(image_url.value!, image_url.value!, "")
          : null,
        comment.value,
        null,
        new Date(),
        new Date(),
        null
      );

      temp.is_posting = true;

      albums.value.unshift(temp);

      image_url.value = null;
      comment.value = "";

      const album = await Album.registerForDecedent(
        decedent_id.value,
        store.state.customer!.id,
        temp.media_url,
        temp.comment
      );

      // console.log(album);

      albums.value.splice(albums.value.indexOf(temp), 1);

      if (!album) {
        return;
      }

      albums.value.unshift(album);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const confirmDeleteAlbum = (album: Album) => {
  console.log('confirmDeleteAlbum');
  showing_modal.value = true;
  target_album.value = album;
};

const closeModal = () => {
  target_album.value = null;
  show_follow_options.value = false;
  show_praying_image.value = false;
  showing_modal.value = false;
};

const deleteAlbum = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      await Album.delete(target_album.value!.target_id, target_album.value!.timestamp);

      albums.value.splice(albums.value.indexOf(target_album.value!), 1);

      closeModal();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const doApprove = (album: Album) => {
  console.log('doApprove');
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      await Album.approve(album.target_id, album.timestamp, true);
      album.approved = true;

      image_url.value = null;
      comment.value = "";
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const showFollowOption = () => {
  show_follow_options.value = true;
  showing_modal.value = true;
};

const follow = (type: string) => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      show_follow_options.value = false;
      following.value = true;
      if (decedent.value) {
        decedent.value.follower_count = decedent.value!.follower_count! + 1;
      }

      const success = await Customer.follow(
        "decedent",
        store.state.customer!.id,
        decedent_id.value,
        type
      );

      if (success) {
        await getFollwingAndRelationshipAsync();
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const unfollow = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      following.value = false;
      if (decedent.value) {
        decedent.value.follower_count = decedent.value.follower_count! - 1;
      }

      const success = await Customer.unfollow(
        store.state.customer!.id,
        decedent_id.value
      );

      if (!success) {
        following.value = true;
        if (decedent.value) {
          decedent.value.follower_count = decedent.value.follower_count! + 1;
        }
      } else {
        await getFollwingAndRelationshipAsync();

        if (!canViewDecedentAlbum.value && type.value == 'album') {
          setType('event');
        }
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

onMounted(() => {
  decedent_id.value = route.params.decedent_id as string;
  refresh();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa = _resolveComponent("fa")!
  const _component_text_clamp = _resolveComponent("text-clamp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(AppHeader),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "h-48 w-full object-cover lg:h-48",
            src: require('@/assets/images/universe_image.png'),
            alt: ""
          }, null, 8, _hoisted_2)
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "h-24 w-24 rounded-full ring-4 ring-white bg-white sm:h-32 sm:w-32 mx-auto",
                    src: decedent.value?.selfie_image_url ?? require('@/assets/images/no-image.png')
                    ,
                    alt: ""
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("h1", _hoisted_8, " 故 " + _toDisplayString(decedent.value?.nickname ? decedent.value?.nickname + '（'+ decedent.value?.name +'）' : decedent.value?.name), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (decedent.value?.birthplace)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("dd", _hoisted_13, _toDisplayString(decedent.value?.birthplace), 1)
                ]))
              : _createCommentVNode("", true),
            (decedent.value?.buddist_name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("dd", _hoisted_16, _toDisplayString(decedent.value?.buddist_name), 1)
                ]))
              : _createCommentVNode("", true),
            (decedent.value?.age)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("dd", _hoisted_19, _toDisplayString(decedent.value?.age), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _hoisted_21,
              _createElementVNode("dd", _hoisted_22, [
                _createElementVNode("button", {
                  class: "flex flex-col justify-center items-center",
                  onClick: showFollowerList
                }, _toDisplayString(decedent.value?.follower_count || "0"), 1)
              ])
            ]),
            _hoisted_23,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_24, [
                (is_my_decedent.value)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      type: "button",
                      class: "inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-white bg-color-2",
                      to: `/decedents/${decedent.value?.id}/edit`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
                (!is_my_decedent.value && following.value === false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-white bg-color-2",
                          onClick: _withModifiers(showFollowOption, ["stop"])
                        }, [
                          _createTextVNode(" フォロー "),
                          _hoisted_28
                        ], 8, _hoisted_27)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!is_my_decedent.value && following.value === true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-white bg-color-2",
                      onClick: unfollow
                    }, _hoisted_30))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("dl", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("dt", _hoisted_34, [
                _createElementVNode("button", {
                  class: "ml-2 text-sm text-gray-800 flex items-center justify-center",
                  onClick: togglePraying
                }, [
                  _createElementVNode("img", {
                    class: "w-6 h-6 mr-2",
                    src: require('@/assets/images/omairiIconNavy.png')
                  }, null, 8, _hoisted_35),
                  _createTextVNode("お参り ")
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("img", {
              class: "h-6 w-6",
              src: require('@/assets/images/no-image.png')
            }, null, 8, _hoisted_39),
            _createElementVNode("span", _hoisted_40, "お参り履歴 " + _toDisplayString(decedent.value?.stamp_count), 1),
            _createVNode(_component_fa, {
              icon: "angle-right",
              class: "ml-2 text-xl text-gray-400"
            })
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("nav", _hoisted_42, [
            (canViewDecedentAlbum.value)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  class: _normalizeClass(["w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm", {
              'border-color-2': type.value == 'album',
              'border-transparent': type.value != 'album',
              'text-color-2': type.value == 'album',
              'border-b-2': type.value == 'album',
            }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (setType('album')))
                }, _toDisplayString(decedent.value?.is_celebrity ? 'アルバム' : '思い出・供養'), 3))
              : _createCommentVNode("", true),
            (!decedent.value?.is_celebrity)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "javascript:void(0)",
                  class: _normalizeClass(["w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm", {
              'border-color-2': type.value == 'event',
              'border-transparent': type.value != 'event',
              'text-color-2': type.value == 'event',
              'border-b-2': type.value == 'event',
            }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setType('event')))
                }, " 法要 ", 2))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              href: "javascript:void(0)",
              class: _normalizeClass(["w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm", {
              'border-color-2': type.value == 'attribute',
              'border-transparent': type.value != 'attribute',
              'text-color-2': type.value == 'attribute',
              'border-b-2': type.value == 'attribute',
            }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (setType('attribute')))
            }, " 故人について ", 2)
          ])
        ])
      ]),
      (type.value == 'album')
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            (!decedent.value?.is_celebrity)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("form", _hoisted_46, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["border rounded-lg shadow-sm overflow-hidden", {
                'border-gray-300': !comment_error.value,
                'border-red-200': !!comment_error.value,
              }])
                      }, [
                        _hoisted_47,
                        _withDirectives(_createElementVNode("textarea", {
                          rows: "3",
                          name: "comment",
                          id: "comment",
                          class: "block w-full py-3 border-0 resize-none sm:text-sm",
                          placeholder: "あなたのお名前、思い出の写真・動画や、エピソード等を投稿いただけます",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((comment).value = $event)),
                          onFocus: onCommentFocus
                        }, null, 544), [
                          [_vModelText, comment.value]
                        ]),
                        (image_url.value)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "ml-2 mt-2 w-32",
                              src: image_url.value
                            }, null, 8, _hoisted_48))
                          : _createCommentVNode("", true),
                        _hoisted_49
                      ], 2),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "-m-2.5 w-10 h-10 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-500",
                              onClick: _withModifiers(onAttachmentButtonClicked, ["prevent"])
                            }, [
                              _createVNode(_component_fa, { icon: "image" })
                            ], 8, _hoisted_53),
                            _createElementVNode("input", {
                              type: "file",
                              ref_key: "uploadfile",
                              ref: uploadfile,
                              class: "hidden",
                              accept: "image/*",
                              onChange: onUploadFileChanged
                            }, null, 544)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("button", {
                            type: "submit",
                            class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-color-2",
                            onClick: _withModifiers(registerAlbum, ["prevent"])
                          }, " 思い出を投稿 ", 8, _hoisted_55)
                        ])
                      ])
                    ]),
                    (comment_error.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(comment_error.value), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_57, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(albums.value, (album) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `${album.created_at}`,
                  class: "relative p-4 bg-white lg:w-xl md:w-xl"
                }, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("img", {
                        class: "h-6 w-6 rounded-full bg-gray-100",
                        src: album.publisher_selfie_image_url
                      }, null, 8, _hoisted_60)
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("p", _hoisted_63, _toDisplayString(formatAlbumTitle(album)), 1)
                    ]),
                    (is_my_decedent.value || album.publisher_id == my_id.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _withModifiers(($event: any) => (confirmDeleteAlbum(album)), ["prevent"])
                        }, [
                          _createVNode(_component_fa, {
                            icon: "ellipsis-v",
                            class: "text-gray-400"
                          })
                        ], 8, _hoisted_64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    (album.media_url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          _createElementVNode("img", {
                            src: album.media_url?.original_resource_url,
                            alt: "",
                            class: "object-cover pointer-events-none group-hover:opacity-75"
                          }, null, 8, _hoisted_67)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", {
                    class: "mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none",
                    innerHTML: album.comment_v
                  }, null, 8, _hoisted_68),
                  _createElementVNode("div", _hoisted_69, [
                    (is_my_decedent.value || album.publisher_id == my_id.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(album.approved_v), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_71, _toDisplayString(album.is_posting ? "投稿中..." : formatdt(album.created_at)), 1)
                  ]),
                  (!album.is_posting && album.approved == null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500",
                          onClick: ($event: any) => (doApprove(album))
                        }, _hoisted_75, 8, _hoisted_73)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (type.value == 'event')
        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
            _createElementVNode("main", null, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("ul", _hoisted_78, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelines.value, (timeline) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: timeline.id,
                      class: "relative p-4 bg-white"
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/timelines/${timeline.id}`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              (!!timeline.media_urls && !!timeline.media_urls.length)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: timeline.media_urls[0].original_resource_url,
                                    alt: "",
                                    class: "object-cover pointer-events-none group-hover:opacity-75"
                                  }, null, 8, _hoisted_81))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_82, _toDisplayString(timeline.title), 1),
                          _createElementVNode("p", {
                            class: "mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none",
                            innerHTML: timeline.body
                          }, null, 8, _hoisted_83),
                          _createElementVNode("div", _hoisted_84, [
                            _createElementVNode("span", _hoisted_85, [
                              _createElementVNode("button", _hoisted_86, [
                                _createElementVNode("img", {
                                  class: "w-4 h-4",
                                  src: require('@/assets/images/ic_comment.png')
                                }, null, 8, _hoisted_87),
                                _createElementVNode("span", _hoisted_88, _toDisplayString(timeline.comment_count), 1),
                                _hoisted_89
                              ])
                            ]),
                            _createElementVNode("span", _hoisted_90, [
                              _createElementVNode("button", _hoisted_91, [
                                _createElementVNode("img", {
                                  class: "w-4 h-4",
                                  src: require('@/assets/images/ic_stamp1_circle.png')
                                }, null, 8, _hoisted_92),
                                _createElementVNode("span", _hoisted_93, _toDisplayString(timeline.stamp_count), 1),
                                _hoisted_94
                              ])
                            ]),
                            _hoisted_95,
                            _createElementVNode("span", _hoisted_96, _toDisplayString(formatdt(timeline.created_at)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (type.value == 'attribute')
        ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("dl", _hoisted_99, [
                  (decedent.value?.date_of_dead)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                        _hoisted_101,
                        _createElementVNode("dd", _hoisted_102, _toDisplayString(decedent.value?.date_of_dead), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (decedent.value?.date_of_birth)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                        _hoisted_104,
                        _createElementVNode("dd", _hoisted_105, _toDisplayString(decedent.value?.date_of_birth), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (decedent.value?.introduce)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                        _hoisted_107,
                        _createElementVNode("dd", _hoisted_108, _toDisplayString(decedent.value?.introduce), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (decedent.value?.birthplace)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                        _hoisted_110,
                        _createElementVNode("dd", _hoisted_111, _toDisplayString(decedent.value?.birthplace), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (decedent.value?.hobby)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                        _hoisted_113,
                        _createElementVNode("dd", _hoisted_114, _toDisplayString(decedent.value?.hobby), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (decedent.value?.school)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                        _hoisted_116,
                        _createElementVNode("dd", _hoisted_117, _toDisplayString(decedent.value?.school), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (decedent.value?.job)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                        _hoisted_119,
                        _createElementVNode("dd", _hoisted_120, _toDisplayString(decedent.value?.job), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (decedent.value?.conferment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                        _hoisted_122,
                        _createElementVNode("dd", _hoisted_123, _toDisplayString(decedent.value?.conferment), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (show_follower_list.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
            _hoisted_125,
            _createElementVNode("div", _hoisted_126, [
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_129, [
                      _hoisted_130,
                      _createElementVNode("button", {
                        class: "flex items-center justify-center h-8 w-8 rounded-full bg-gray-100",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (show_follower_list.value = false))
                      }, [
                        _createVNode(_component_fa, { icon: "times" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("div", _hoisted_132, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(followers.value, (follower) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "flex items-center mb-4",
                            key: follower.id
                          }, [
                            _createElementVNode("img", {
                              class: "hidden h-8 w-8 rounded-full sm:block",
                              src: follower.selfie_image_url ??
                        require('@/assets/images/no-selfie.png')
                        
                            }, null, 8, _hoisted_133),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_134, [
                                _createElementVNode("img", {
                                  class: "h-6 w-6 rounded-full",
                                  src: follower.selfie_image_url ??
                            require('@/assets/images/no-selfie.png')
                            ,
                                  alt: ""
                                }, null, 8, _hoisted_135),
                                _createElementVNode("div", _hoisted_136, [
                                  _createElementVNode("span", _hoisted_137, _toDisplayString(follower.display_name), 1),
                                  _createElementVNode("span", _hoisted_138, _toDisplayString(follower.relationship), 1)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (show_follower_list.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
            _hoisted_140,
            _createElementVNode("div", _hoisted_141, [
              _createElementVNode("div", _hoisted_142, [
                _createElementVNode("div", _hoisted_143, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_144, [
                      _hoisted_145,
                      _createElementVNode("button", {
                        class: "flex items-center justify-center h-8 w-8 rounded-full bg-gray-100",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (show_follower_list.value = false))
                      }, [
                        _createVNode(_component_fa, { icon: "times" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_146, [
                      _createElementVNode("div", _hoisted_147, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(followers.value, (follower) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "flex items-center mb-4",
                            key: follower.id
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_148, [
                                _createElementVNode("img", {
                                  class: "h-6 w-6 rounded-full",
                                  src: follower.selfie_image_url ??
                            require('@/assets/images/no-selfie.png')
                            ,
                                  alt: ""
                                }, null, 8, _hoisted_149),
                                _createElementVNode("div", _hoisted_150, [
                                  _createElementVNode("span", _hoisted_151, _toDisplayString(follower.display_name), 1),
                                  _createElementVNode("span", _hoisted_152, _toDisplayString(follower.relationship), 1)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (showing_modal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 w-full h-full",
          style: {"background-color":"#999999aa"},
          onClick: _withModifiers(closeModal, ["stop"])
        }, [
          (show_follow_options.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                _createElementVNode("div", _hoisted_155, [
                  _hoisted_156,
                  _hoisted_157,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(decedent.value.relationships, (relationship) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: "text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100",
                      key: relationship,
                      onClick: ($event: any) => (follow(relationship))
                    }, _toDisplayString(relationship), 9, _hoisted_158))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (show_praying_image.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                _createElementVNode("img", {
                  src: require('@/assets/images/bell1.jpg'),
                  class: "w-2/3"
                }, null, 8, _hoisted_160)
              ]))
            : _createCommentVNode("", true),
          (target_album.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                _createElementVNode("div", _hoisted_162, [
                  _createElementVNode("div", _hoisted_163, [
                    _createElementVNode("div", _hoisted_164, [
                      (!!target_album.value?.media_url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: target_album.value?.media_url?.original_resource_url,
                            alt: "",
                            class: "object-cover pointer-events-none group-hover:opacity-75"
                          }, null, 8, _hoisted_165))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_text_clamp, {
                      text: target_album.value?.comment,
                      "max-lines": 2,
                      class: "mt-2 block text-sm font-medium text-gray-900 pointer-events-none"
                    }, null, 8, ["text"]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "mt-8 inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm",
                      onClick: _withModifiers(deleteAlbum, ["stop"])
                    }, " このアルバムを削除 ", 8, _hoisted_166)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_153))
      : _createCommentVNode("", true)
  ]))
}
}

})